export const EDGE_GATEWAYS_RESET_STATE = 'EDGE_GATEWAYS_RESET_STATE';
export const EDGE_GATEWAYS_CURRENT_ITEM = 'EDGE_GATEWAYS_CURRENT_ITEM';

export const EDGE_GATEWAYS_REQUEST_LOADING = 'EDGE_GATEWAYS_REQUEST_LOADING';
export const EDGE_GATEWAYS_REQUEST_SUCCESS = 'EDGE_GATEWAYS_REQUEST_SUCCESS';
export const EDGE_GATEWAYS_REQUEST_FAILED = 'EDGE_GATEWAYS_REQUEST_FAILED';

export const EDGE_GATEWAYS_CURRENT_ACTION = 'EDGE_GATEWAYS_CURRENT_ACTION';
export const EDGE_GATEWAYS_RESET_ACTION = 'EDGE_GATEWAYS_RESET_ACTION';